var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

const SvgIconHeartFilled = (_ref) => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 27,
    viewBox: "0 0 27 27",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.958 6.973A5.39 5.39 0 0 0 18.236 5.5a5.39 5.39 0 0 0-3.722 1.473l-1.014.97-1.014-.97c-2.056-1.963-5.389-1.963-7.444 0-2.056 1.964-2.056 5.149 0 7.113l1.014.969 7.444 7.112 7.444-7.112 1.014-.97A4.917 4.917 0 0 0 23.5 10.53a4.917 4.917 0 0 0-1.542-3.557z",
    fill: "#E2430C",
    stroke: "#E2430C",
    strokeWidth: 2,
    fillRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIconHeartFilled, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/icon-heart-filled.00aff9e9.svg";
export { ForwardRef as ReactComponent };